import React from "react";

// Orange martini hero shot (kept) + real venue photos
const MARTINI = "https://static.prod-images.emergentagent.com/jobs/86dbb7be-8e31-4f59-a434-2b11ea866542/images/08a8f0025034cf7ba2e38d6529a2e6dca8d75b144dd561e70bbf098cdf641cd0.png";
const LOUNGE = "https://customer-assets.emergentagent.com/job_venue-events-hub/artifacts/3p8vb4ec_next%20lounge.webp";
const PERFORMERS = "https://customer-assets.emergentagent.com/job_venue-events-hub/artifacts/ut33rad4_perfromer.jpg";
const DRINK = "https://customer-assets.emergentagent.com/job_venue-events-hub/artifacts/x38fwx96_next%20drink.jpg";
const BOYS = "https://customer-assets.emergentagent.com/job_venue-events-hub/artifacts/grjl41jn_next%20boys.jpg";

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="relative py-24 md:py-32 bg-neutral-950">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-16">
        <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-4">Inside the House</p>
        <h2 className="font-serif font-light text-white text-4xl md:text-5xl lg:text-6xl tracking-tight">
          A room with <span className="italic text-[#D4AF37]">presence</span>
        </h2>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-3 md:gap-4">
          <div className="col-span-12 md:col-span-7 aspect-[4/3] overflow-hidden group" data-testid="gallery-img-0">
            <img src={MARTINI} alt="Signature cocktail" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" />
          </div>
          <div className="col-span-12 md:col-span-5 aspect-[4/3] overflow-hidden group" data-testid="gallery-img-1">
            <img src={LOUNGE} alt="Lounge interior with disco ball and velvet seating" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" />
          </div>

          <div className="col-span-6 md:col-span-6 aspect-[4/5] overflow-hidden group" data-testid="gallery-img-2">
            <img src={PERFORMERS} alt="Live performers on stage" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" />
          </div>
          <div className="col-span-6 md:col-span-6 aspect-[4/5] overflow-hidden group" data-testid="gallery-img-3">
            <img src={DRINK} alt="Signature bathtub cocktail" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" />
          </div>

          <div className="col-span-12 aspect-[21/9] overflow-hidden group" data-testid="gallery-img-4">
            <img src={BOYS} alt="Guests at Next Bar & Lounge" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" />
          </div>
        </div>
      </div>
    </section>
  );
}
